import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import morthLogo from "@assets/svg/morth-logo.svg";
// import NEmblem from "../../assets/images/logo/National-Emblem.svg";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Avatar,
  Typography,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Link as MuiLink,
  Divider,
  Button,
  Stack,
} from "@mui/material";
import { toggleUserProfile } from "../../modules/profile/redux/profileSlice";
import { RootState, AppDispatch } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import Profile from "@modules/profile";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { Link, useNavigate } from "react-router-dom";
import { logoutThunk } from "@modules/login/redux/thunk/loginThunk";
import commonlogin from "../../assets/svg/emblem-commonlogin.svg";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { useTheme, useMediaQuery } from "@mui/material";
import { openFileBySignedUrl } from "../../utils/getViewSignedUrlHandler";
import { getViewFileROWSignedUrl } from "@modules/stepper/services/apiEndPoints";
import { getFileROWSignedURLThunk } from "@modules/stepper/redux/thunk/documentThunk";

const DashboardHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [docsAnchorEl, setDocsAnchorEl] = React.useState<null | HTMLElement>(
    null,
  );
  const [guidelinesAnchorEl, setGuidelinesAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const openDocsMenu = (e: React.MouseEvent<HTMLElement>) =>
    setDocsAnchorEl(e.currentTarget);
  const closeDocsMenu = () => setDocsAnchorEl(null);
  const openGuidelinesMenu = (e: React.MouseEvent<HTMLElement>) =>
    setGuidelinesAnchorEl(e.currentTarget);
  const closeGuidelinesMenu = () => setGuidelinesAnchorEl(null);
  const navigate = useNavigate();
  const isUserProfileOpen = useSelector(
    (state: RootState) => state.profile.isUserProfileOpen,
  );
  const dispatch = useDispatch<AppDispatch>();

  const { profile } = useSelector((state: RootState) => state.profile);

  function getFirstAndLastInitial(name: string): string {
    if (!name) return "";

    const words = name.trim().split(/\s+/); // split by spaces
    const first = words[0]?.[0]?.toUpperCase() || "";
    const last =
      words.length > 1 ? words[words.length - 1][0].toUpperCase() : "";

    return first + last;
  }

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewProfile = () => {
    dispatch(toggleUserProfile(!isUserProfileOpen));
    handleMenuClose();
  };

  const handleLogout = async () => {
    const confirmation = window.confirm(
      "You are about to log out. Do you wish to continue?",
    );
    if (!confirmation) return;
    localStorage.clear();
    await dispatch(logoutThunk()).then((resp) => {
      if (resp.payload.success) {
        window.location.href = "/";
      }
    });
    handleMenuClose();
    handleDrawerToggle();
  };

  const handleViewProfileNew = () => {
    handleMenuClose();
    navigate("/view-profile");
    handleDrawerToggle();
  };

  const handleGo = (path: string) => {
    navigate(path);
    closeDocsMenu();
    closeGuidelinesMenu();
  };
  const handleExternal = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
    closeGuidelinesMenu();
    handleDrawerToggle();
  };

  const handleOpenUserManual = (documentName: string) => {
    openFileBySignedUrl({
      document_name: documentName,
      dispatch,
      getSignedUrlThunk: getFileROWSignedURLThunk,
    });
  };

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{ bgcolor: "#3a1a76", height: 32, justifyContent: "center" }}
      >
        <Toolbar>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{ flexGrow: 1, minWidth: 0 }}
          >
            <img
              src={require("@assets/images/flag.jpg")}
              alt="India Flag"
              style={{ width: 33, height: 20, borderRadius: 2 }}
            />
            <Typography
              color="#fff"
              sx={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}
            >
              <MuiLink
                href="https://india.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="#fff"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  fontSize: 12,
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  "&:hover": { color: "#fff" },
                }}
                aria-label="Open Government of India website"
              >
                Government of India
                <OpenInNewOutlinedIcon
                  sx={{ fontSize: 16, color: "#cbb8ff" }}
                />
              </MuiLink>
            </Typography>
          </Stack>
          <div className="flex mr-4 items-center gap-1">
            <span style={{ fontSize: 12 }} className="">
              Select Language
            </span>
            <div className="bhashini-plugin-container"></div>
          </div>
        </Toolbar>
      </AppBar>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "none",
          height: 72,
          justifyContent: "center",
          p: 0,
          mb: 2,
          zIndex: 50,
        }}
      >
        <Toolbar
          sx={{
            maxWidth: 1300,
            width: "100%",
            mx: "auto",
            display: "flex",
            justifyContent: "space-between",
            p: "0 !important",
            minHeight: { xs: 56, sm: 72 },
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              cursor: "pointer",
            }}
            onClick={() =>
              profile?.user_category && navigate("/application-dashboard")
            }
          >
            <Box sx={{ textAlign: "left" }}>
              <img
                src={require("@assets/images/logo/RajmargPraveshLogo.png")}
                alt="MoRTH Logo"
                className="morth-logo"
              />
            </Box>
          </Box>

          {/* Hamburger for mobile */}
          <Box
            sx={{ display: { xs: "flex", md: "none" }, alignItems: "center" }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ ml: 1 }}
            >
              <MenuIcon sx={{ color: "#3a1a76", fontSize: 32 }} />
            </IconButton>
          </Box>
          {/* Desktop nav links */}
          <Box
            sx={{
              flex: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "end",
              alignItems: "center",
              gap: 3,
              mr: 4,
            }}
          >
            {/* Desktop nav links here (unchanged) */}
            <MuiLink
              component={Link}
              to="/application-dashboard/public-comments"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#212121",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "1.1rem",
                gap: 1,
                textDecorationColor: "currentColor",
                "&&:hover": {
                  color: "#212121",
                  textDecoration: "underline",
                  textDecorationColor: "currentColor",
                  backgroundColor: "transparent",
                },
                "&&:focus, &&:active": {
                  color: "#212121",
                  backgroundColor: "transparent",
                },
              }}
            >
              Invitation of Public Comments
            </MuiLink>
            <MuiLink
              component={Link}
              to="/application-dashboard/guidelines"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#212121",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "1.1rem",
                gap: 1,
                textDecorationColor: "currentColor",
                "&&:hover": {
                  color: "#212121",
                  textDecoration: "underline",
                  textDecorationColor: "currentColor",
                  backgroundColor: "transparent",
                },
                "&&:focus, &&:active": {
                  color: "#212121",
                  backgroundColor: "transparent",
                },
              }}
            >
              Guidelines
            </MuiLink>
            <Menu
              anchorEl={guidelinesAnchorEl}
              disableScrollLock
              open={Boolean(guidelinesAnchorEl)}
              onClose={closeGuidelinesMenu}
              MenuListProps={{
                autoFocusItem: false,
                onMouseLeave: closeGuidelinesMenu,
                sx: {
                  "& .MuiMenuItem-root": {
                    color: "#212121",
                    "&&:hover": {
                      backgroundColor: "#FAFAFA",
                      color: "#212121",
                    },
                    "&&.Mui-focusVisible": { backgroundColor: "transparent" },
                    "&&:focus": { backgroundColor: "transparent" },
                    "&&.Mui-selected, &&.Mui-selected:hover": {
                      backgroundColor: "transparent",
                      color: "#212121",
                    },
                  },
                },
              }}
              PaperProps={{
                sx: {
                  mt: 1,
                  borderRadius: 2,
                  boxShadow: "0px 4px 24px rgba(0,0,0,0.10)",
                },
              }}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem
                sx={{ fontSize: "1.1rem", fontWeight: 500, color: "#212121" }}
                disableRipple
                component="a"
                href="/GuidelinesAccessPermissions.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Guidelines of access permissions
              </MenuItem>
              <MenuItem
                sx={{ fontSize: "1.1rem", fontWeight: 500, color: "#212121" }}
                disableRipple
                component="a"
                href="/GuidelinesROWAccessPermissions.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Guidelines of ROW permissions
              </MenuItem>
              <MenuItem
                sx={{ fontSize: "1.1rem", fontWeight: 500, color: "#212121" }}
                disableRipple
                component="a"
                href="/NHAct2002.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Control of NH Act
              </MenuItem>
            </Menu>
            <MuiLink
              component={Link}
              to="/faq"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#212121",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "1.1rem",
                gap: 1,
                textDecorationColor: "currentColor",
                "&&:hover": {
                  color: "#212121",
                  textDecoration: "underline",
                  textDecorationColor: "currentColor",
                  backgroundColor: "transparent",
                },
                "&&:focus, &&:active": {
                  color: "#212121",
                  backgroundColor: "transparent",
                },
              }}
            >
              FAQ
            </MuiLink>
            <MuiLink
              component={Link}
              to="/help-desk"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#212121",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "1.1rem",
                gap: 1,
                textDecorationColor: "currentColor",
                "&&:hover": {
                  color: "#212121",
                  textDecoration: "underline",
                  textDecorationColor: "currentColor",
                  backgroundColor: "transparent",
                },
                "&&:focus, &&:active": {
                  color: "#212121",
                  backgroundColor: "transparent",
                },
              }}
            >
              Help Desk
            </MuiLink>
            <MuiLink
              onClick={() => handleOpenUserManual("user-manual.pdf")}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#212121",
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "1.1rem",
                gap: 1,
                textDecorationColor: "currentColor",
                "&&:hover": {
                  color: "#212121",
                  textDecoration: "underline",
                  textDecorationColor: "currentColor",
                  backgroundColor: "transparent",
                },
                "&&:focus, &&:active": {
                  color: "#212121",
                  backgroundColor: "transparent",
                },
              }}
            >
              User Manual
            </MuiLink>
          </Box>
          {/* End nav section, no extra closing Box here */}
          {/* Right Section */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              bgcolor: "#F3F4F6",
              borderRadius: 3,
              px: 1.25,
              py: 0.05,
              paddingRight: 0,
            }}
          >
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "18px",
                  letterSpacing: "-0.5px",
                  textAlign: "right",
                  color: "#212121",
                }}
              >
                {profile?.name}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  color: "#757575",
                  fontSize: "12px",
                  lineHeight: 1.4,
                }}
              >
                Applicant
              </Typography>
            </Box>

            <IconButton onClick={handleAvatarClick}>
              <Avatar
                sx={{
                  width: 36,
                  height: 36,
                  backgroundColor: "#3a1c73",
                  boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.12)",
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "white", fontSize: "1rem", fontWeight: "bold" }}
                >
                  {profile && getFirstAndLastInitial(profile.name)}
                </Typography>
              </Avatar>
              <KeyboardArrowDownIcon
                sx={{
                  color: "#222",
                  fontSize: 28,
                  ml: 0.5,
                  transition: "transform 0.2s",
                  transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              disableScrollLock
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  minWidth: 160,
                  boxShadow: "0px 4px 24px rgba(0,0,0,0.10)",
                },
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={handleViewProfileNew}>
                <ListItemIcon className="body-xs">
                  <AccountCircleOutlinedIcon style={{ color: "#1C1B1F" }} />
                </ListItemIcon>
                <ListItemText
                  primary="View Profile"
                  className="body-xs font-medium"
                  primaryTypographyProps={{ sx: { color: "#1C1B1F" } }}
                />
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <ListItemIcon className="body-xs font-medium">
                  <LogoutIcon sx={{ color: "#C62828" }} />
                </ListItemIcon>
                <ListItemText
                  onClick={() => {
                    console.log("logout");
                  }}
                  primary="Logout"
                  primaryTypographyProps={{ sx: { color: "#212121" } }}
                />
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
        {isMobile && (
          <Drawer
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: "70vw" },
            }}
          >
            <Box sx={{ width: 260, p: 2 }} role="presentation">
              <Box sx={{ textAlign: "left" }}>
                <img
                  src={require("@assets/images/logo/RajmargPraveshLogo.png")}
                  alt="MoRTH Logo"
                  className="morth-logo"
                  style={{ marginLeft: 0 }}
                />
              </Box>
              <Divider sx={{ my: 2 }} />

              <Box
                sx={{
                  display: { xs: "inline-flex", md: "none" },
                  alignItems: "center",
                  bgcolor: "#F3F4F6",
                  borderRadius: 3,
                  px: 1.25,
                  py: 0.05,
                  mb: 2,
                  paddingRight: 0,
                }}
              >
                <Box
                  sx={{
                    display: { xs: "inline-flex", md: "none" },
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "12px",
                      lineHeight: "18px",
                      letterSpacing: "-0.5px",
                      textAlign: "right",
                      color: "#212121",
                    }}
                  >
                    {profile?.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      color: "#757575",
                      fontSize: "12px",
                      lineHeight: 1.4,
                    }}
                  >
                    Applicant
                  </Typography>
                </Box>

                <IconButton onClick={handleAvatarClick}>
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#3a1c73",
                      boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.12)",
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "white",
                        fontSize: "1rem",
                        fontWeight: "bold",
                      }}
                    >
                      {profile && getFirstAndLastInitial(profile.name)}
                    </Typography>
                  </Avatar>
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#222",
                      fontSize: 28,
                      ml: 0.5,
                      transition: "transform 0.2s",
                      transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    sx: {
                      borderRadius: 2,
                      minWidth: 160,
                      boxShadow: "0px 4px 24px rgba(0,0,0,0.10)",
                    },
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem onClick={handleViewProfileNew}>
                    <ListItemIcon className="body-xs">
                      <AccountCircleOutlinedIcon style={{ color: "#1C1B1F" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="View Profile"
                      className="body-xs font-medium"
                      primaryTypographyProps={{ sx: { color: "#1C1B1F" } }}
                    />
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    <ListItemIcon className="body-xs font-medium">
                      <LogoutIcon sx={{ color: "#C62828" }} />
                    </ListItemIcon>
                    <ListItemText
                      onClick={() => {
                        console.log("logout");
                      }}
                      primary="Logout"
                      primaryTypographyProps={{ sx: { color: "#212121" } }}
                    />
                  </MenuItem>
                </Menu>
              </Box>
              <MuiLink
                component={Link}
                to="/application-dashboard/public-comments"
                underline="hover"
                sx={{
                  display: "block",
                  color: "#212121",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
                onClick={handleDrawerToggle}
              >
                Invitation of Public Comments
              </MuiLink>
              <MuiLink
                component={Link}
                to="/application-dashboard/guidelines"
                underline="hover"
                sx={{
                  display: "block",
                  color: "#212121",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
                onClick={handleDrawerToggle}
              >
                Guidelines
              </MuiLink>
              <MuiLink
                component={Link}
                to="/faq"
                underline="hover"
                sx={{
                  display: "block",
                  color: "#212121",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
                onClick={handleDrawerToggle}
              >
                FAQ
              </MuiLink>
              <MuiLink
                component={Link}
                to="/help-desk"
                underline="hover"
                sx={{
                  display: "block",
                  color: "#212121",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
                onClick={handleDrawerToggle}
              >
                Help Desk
              </MuiLink>
              <MuiLink
                href="/user-manual.pdf"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{
                  display: "block",
                  color: "#212121",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
                onClick={handleDrawerToggle}
              >
                User Manual
              </MuiLink>
            </Box>
          </Drawer>
        )}
        <Profile />
        {/* Mobile Drawer for nav links */}
      </AppBar>
    </>
  );
};

export default DashboardHeader;
